export default "__VITE_ASSET__C4NQfGem__"